import React from 'react';

const Resume = () => {
  return (
    <div>
      <p>Resume</p>
    </div>
  );
};

export default Resume;
